import { css } from '@Root/lib/lit-3form-block';

export const styles = [
  css`
    .bill-layout {
      grid-template-rows: minmax(0, auto);
      margin: calc(20rem / var(--default-rem-px-count)) 0;
    }

    .text-wrapper {
      display: flex;
      flex-direction: column;
      margin: 0 calc(20rem / var(--default-rem-px-count));
    }

    .grid-left,
    .grid-center,
    .grid-right {
      grid-column: 2 / 8;
      grid-row: 2;
    }

    .italics {
      font-style: italic;
    }

    .font-size-medium {
      font-size: 1.25em;
      line-height: 1.5em;
    }

    .elements-colors {
      background-color: #305371;
      color: #f8f8f8;
      padding-bottom: calc(40rem / var(--default-rem-px-count));
    }

    .attribution {
      margin-top: calc(10rem / var(--default-rem-px-count));
    }

    @media (min-width: 600px) {
      .bill-layout {
        grid-template-rows:
          var(--top-padding-height)
          minmax(0, auto)
          var(--bottom-padding-height);
        margin: 0;
      }

      .position-wrapper {
        grid-column: 2 / 14;
        grid-row: 2;
        display: flex;
        flex-direction: row;
        width: 100%;
      }

      .text-wrapper {
        width: 50%;
        padding: calc(40rem / var(--default-rem-px-count)) 0;
        margin: unset;
      }

      .elements-colors {
        padding-bottom: calc(80rem / var(--default-rem-px-count));
      }

      .grid-left {
        justify-content: start;
      }

      .grid-center {
        justify-content: center;
      }

      .grid-right {
        justify-content: end;
      }

      .attribution {
        margin-top: calc(20rem / var(--default-rem-px-count));
      }
    }
  `,
];
